import { render, staticRenderFns } from "./ValuePropCashflowGoal.vue?vue&type=template&id=5c05a9a3&scoped=true&"
import script from "./ValuePropCashflowGoal.vue?vue&type=script&lang=js&"
export * from "./ValuePropCashflowGoal.vue?vue&type=script&lang=js&"
import style0 from "./ValuePropCashflowGoal.vue?vue&type=style&index=0&id=5c05a9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05a9a3",
  null
  
)

export default component.exports